export const arAgentTranslations = {
  agent: {
    // Page titles
    title: "إعدادات المساعد الذكي",
    subtitle: "اضبط سلوك وشخصية مساعدك الذكي",
    unsavedChanges: "تغييرات غير محفوظة",
    agentName : "اسم المساعد",
    agentNamePlaceholder : "أدخل اسم مساعدك",

    // Agent Status
    agentStatus: "حالة المساعد",
    agentActive: "مساعدك الذكي نشط وجاهز لمساعدة العملاء",
    agentInactive: "مساعدك الذكي معطل حاليًا",
    active: "نشط",
    inactive: "غير نشط",
    status: "الحالة",

    // Predefined Profiles
    predefinedProfiles: "الملفات الشخصية المحددة مسبقًا",
    predefinedProfilesDesc: "اختر من شخصيات وأساليب المساعد المُعدة مسبقًا",

    profiles: {
      lebaneseCasual: {
        name: "لبناني عادي",
        description: "لهجة لبنانية ودية بأسلوب محادث",
      },
      professionalEnglish: {
        name: "إنجليزي احترافي",
        description: "نبرة احترافية مع نهج استشاري",
      },
      quickService: {
        name: "خدمة سريعة",
        description: "أسلوب خدمة حيوي وسريع الإيقاع",
      },
      chefExpert: {
        name: "خبير الطبخ",
        description: "خبرة طهي دافئة وتعليمية",
      },
    },

    // Tone Options
    tones: {
      friendly: {
        label: "ودي",
        description: "نهج دافئ ومرحب",
      },
      professional: {
        label: "احترافي",
        description: "رسمي ومهذب",
      },
      casual: {
        label: "عادي",
        description: "مريح وغير رسمي",
      },
      humorous: {
        label: "فكاهي",
        description: "خفيف مع النكات",
      },
      warm: {
        label: "دافئ",
        description: "عناية شخصية",
      },
      energetic: {
        label: "حيوي",
        description: "مفعم بالحيوية والنشاط",
      },
    },

    // Language Options
    languages: {
      multilingual: {
        label: "متعدد اللغات",
        description: "التكيف مع لغة المستخدم",
      },
      lebaneseArabish: {
        label: "عربية لبنانية",
        description: "خليط من العربية والإنجليزية",
      },
      english: {
        label: "إنجليزية",
        description: "اللغة الإنجليزية النقية",
      },
      french: {
        label: "فرنسية",
        description: "اللغة الفرنسية",
      },
      arabic: {
        label: "عربية",
        description: "العربية الفصحى",
      },
      mixed: {
        label: "مختلطة",
        description: "خلط اللغات في الرد",
      },
    },

    // Identity Options
    identities: {
      diningAssistant: {
        label: "مساعد الطعام",
        description: "يساعد في تصفح القائمة والطلب",
      },
      chefConsultant: {
        label: "مستشار الطبخ",
        description: "يوفر رؤى الطبخ والتوصيات",
      },
      foodConnoisseur: {
        label: "خبير الطعام",
        description: "معرفة متخصصة بالمطبخ والنكهات",
      },
      friendlyWaiter: {
        label: "نادل ودود",
        description: "خدمة شخصية مثل نادل المطعم",
      },
      nutritionGuide: {
        label: "مرشد التغذية",
        description: "يركز على الاختيارات الصحية والاحتياجات الغذائية",
      },
    },

    // Response Length Options
    responseLengths: {
      short: {
        label: "قصير",
        description: "استجابات موجزة ومختصرة",
      },
      medium: {
        label: "متوسط",
        description: "مستوى تفاصيل متوازن",
      },
      long: {
        label: "طويل",
        description: "مفصل وشامل",
      },
    },

    // Helping Strategy Options
    strategies: {
      conversational: {
        label: "محادث",
        description: "يشارك في حوار طبيعي",
      },
      direct: {
        label: "مباشر",
        description: "إجابات مباشرة إلى النقطة",
      },
      consultative: {
        label: "استشاري",
        description: "يطرح أسئلة لفهم الاحتياجات",
      },
      educational: {
        label: "تعليمي",
        description: "يشرح التفاصيل ويوفر التعلم",
      },
      quickService: {
        label: "خدمة سريعة",
        description: "استجابات سريعة وفعالة",
      },
    },

    // Configuration sections
    basicConfiguration: "الإعدادات الأساسية",
    basicConfigurationDesc: "إعدادات الشخصية والتواصل الأساسية",
    responseConfiguration: "إعدادات الاستجابة",
    responseConfigurationDesc: "تحكم في كيفية استجابة مساعدك للعملاء",
    behaviorSettings: "إعدادات السلوك",
    behaviorSettingsDesc: "اضبط السلوكيات والميزات المحددة",

    // Form fields
    tone: "النبرة",
    selectTone: "اختر النبرة",
    language: "اللغة",
    selectLanguage: "اختر اللغة",
    identity: "الهوية",
    selectIdentity: "اختر الهوية",
    helpingStrategy: "استراتيجية المساعدة",
    selectStrategy: "اختر الاستراتيجية",
    strategy: "الاستراتيجية",
    responseLength: "طول الاستجابة",

    // Behavior toggles
    includeFoodSafety: "تضمين سلامة الطعام",
    includeFoodSafetyDesc: "ذكر المواد المسببة للحساسية والاعتبارات الغذائية",
    mentionFeaturedItems: "ذكر العناصر المميزة",
    mentionFeaturedItemsDesc: "إبراز الأطباق الخاصة والعروض الترويجية",
    useHumor: "استخدام الفكاهة",
    useHumorDesc: "إضافة نكات ودية ومحادثات خفيفة",
    enableOrdering: "تمكين الطلب عبر المساعد",
    enableOrderingDesc: "السماح للعملاء بإجراء الطلبات من خلال المساعد الذكي",

    // Preview section
    configurationPreview: "معاينة الإعدادات",
    currentSettings: "الإعدادات الحالية",
    sampleResponse: "نموذج استجابة",
    sampleResponseContent:
      "{{identity}} بنبرة {{tone}} سيستجيب بطريقة دافئة ومفيدة لاستفسارات العملاء.",

    // Tips section
    tips: "نصائح وأفضل الممارسات",
    tip1Title: "طابق علامتك التجارية",
    tip1Description: "اختر إعدادات تتماشى مع شخصية مطعمك وأسلوب الخدمة.",
    tip2Title: "جرب ملفات شخصية مختلفة",
    tip2Description:
      "جرب الملفات الشخصية المحددة مسبقًا أولاً، ثم خصص لتجد ما يناسبك.",
    tip3Title: "التحديثات المنتظمة",
    tip3Description:
      "اضبط الإعدادات بناءً على ملاحظات العملاء والتغييرات الموسمية.",

    // Error messages
    errors: {
      fetchFailed: "فشل في تحميل إعدادات المساعد",
      saveFailed: "فشل في حفظ إعدادات المساعد",
    },
  },
};
